/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/Checkout/theme';

export const CheckoutTheme = theme;
